<template>
  <div v-if="isshow" class="radishdetail">
    <div class="close" @click="isshow = false">X</div>
    <div class="radishdetail-message">
      <ul>
        <li>
          <h3>{{ radishName }}</h3>
        </li>
      </ul>
    </div>
    <div class="radishdetail-score">
      <div class="alertbox">
        <el-alert
          title="实心星号表示正分，空心表示负分，分数前边的加减号点击切换状态（表示切换后的状态）"
          type="warning"
        >
        </el-alert>
      </div>
      <div class="score">
        <div class="score-left">
          <ul>
            <li v-for="(type, field) in scoretype" :key="field">
              <div class="score-title">{{ field }}</div>
              <div class="score-score">
                <i v-if="score[field] >= 0" class="el-icon-star-on"></i> <i v-else class="el-icon-star-off"></i>
                <span>{{ score[field] }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="score-right">
          <ul>
            <li v-for="(type, field) in scoretype" :key="field">
              <i class="el-icon-remove-outline btn" v-if="type == '+'" @click="changetype(field, '-')"></i>
              <i class="el-icon-circle-plus-outline btn" v-else-if="type == '-'" @click="changetype(field, '+')"></i>
              <el-rate
                v-model="score[field]"
                v-if="type == '+'"
                void-icon-class="el-icon-star-on"
                :icon-classes="['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on']"
                style="width:85%;display:inline-block"
              ></el-rate>
              <el-rate
                v-model="score[field]"
                v-else-if="type == '-'"
                :colors="['#da3c3c', '#da3c3c', '#da3c3c']"
                void-icon-class="el-icon-remove"
                :icon-classes="['el-icon-remove', 'el-icon-remove', 'el-icon-remove']"
                style="width:85%;display:inline-block"
              ></el-rate>
            </li>
          </ul>
        </div>
        <div class="radish-btn radish-btn-primary radish-btn-small" style="float:right;margin:8px;" @click="savescore">
          保存评分
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      evaluate: '',
      isshow: false,
      radishId: '',
      projectId: '',
      score: {},
      scoretype: {},
      radishName: '',
      submiting: false,
    }
  },
  methods: {
    async open(params) {
      // console.log(params)
      let { radishId, projectId, projectTags, projectScore, radishName } = params
      this.radishId = radishId
      this.projectId = projectId
      this.radishName = radishName
      projectScore = projectScore || {}
      const scoretype = {}
      const score = {}
      projectTags.forEach(tag => {
        scoretype[tag] = projectScore[tag] && projectScore[tag] < 0 ? '-' : '+'
        if (!projectScore[tag]) {
          score[tag] = 0
        } else {
          score[tag] = projectScore[tag] > 0 ? projectScore[tag] : -projectScore[tag]
        }
      })
      this.scoretype = scoretype
      this.score = score
      this.isshow = true
    },
    changetype(type, val) {
      this.scoretype[type] = val
    },
    async savescore() {
      if (this.submiting) return this.$message('提交中，请勿重复提交')
      this.submiting = true
      let score = JSON.parse(JSON.stringify(this.score))
      for (let key in this.scoretype) {
        if (this.scoretype[key] == '-') {
          score[key] = -score[key]
        }
      }
      // console.log(score)
      const result = await app.service('radish').modifyPingfen({ rid: this.radishId, pid: this.projectId, score })
      if (result.status == 'success') {
        // 大于3更新人选沟通
        const tags = []
        Object.keys(score).forEach(tag => {
          if (score[tag] > 3) {
            tags.push(tag)
          }
        })
        const res = await app.service('radish').modifyCommunicateTags({ rid: this.radishId, tags })
        this.$parent.updateOne(this.radishId, 'pingfen', score)
        this.$message.success('保存成功')
        this.isshow = false
      }
      this.submiting = false
    },
  },
}
</script>
<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
}

i {
  font-size: 18px;
  color: #f9152a;
}

ul {
  padding: 0;
  list-style: none;
}

.radishdetail {
  position: fixed;
  top: 100px;
  left: calc(50vw - 178px);
  z-index: 1600;
  width: 356px;
  padding: 16px 16px 0;
  background-color: #fff;
  border: 1px #c1c1c1 solid;
  border-radius: 5px;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}

.radishdetail .close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background-color: #e83939;
  border-radius: 50%;
}

.radishdetail-message li {
  margin-bottom: 5px;
}

.savemember {
  position: absolute;
  top: 10px;
  right: 36px;
  z-index: 4;
}

.radishdetail-score {
  background-color: #fff;
}

.average {
  height: 30px;
  padding: 0 16px;
  margin: 0 -16px;
  line-height: 30px;
  text-align: center;
  background-color: skyblue;
  border-radius: 5px;
}

.alertbox {
  margin: 0 -16px;
}

.score-title {
  float: left;
}

.score-content {
  margin: 0 auto;
}

.score-left,
.score-right {
  float: left;
  width: 50%;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.score-left {
  border-right: 1px solid #eee;
}

.score-right {
  padding-left: 16px;
}

.score-left li {
  overflow: hidden;
  line-height: 32px;
}

.score-right li {
  display: flex;
  align-items: center;
  height: 32px;
}

.score-score {
  float: right;
  margin-right: 20px;
}

.score-score i {
  color: rgb(247, 186, 42);
}

.btn {
  font-size: 20px;
  color: #807f7f;
  text-align: center;
  cursor: pointer;
}

.evaluate {
  float: left;
  width: 100%;
  padding-top: 8px;
  overflow: hidden;
}
.grades-box {
  max-height: 200px;
  overflow: auto;
  width: 100%;
}
.grades-evaluate {
  color: #807f7f;
  padding-left: 8px;
}
</style>
